'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/app-skeleton';
import { Panel, PanelContent, PanelHeader } from '@/components/ui/panel';

// ---------------------------------------------------------------------------
// Single-row skeleton placeholder
// ---------------------------------------------------------------------------

function RowSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-3 border-b py-3"><Skeleton className="h-4 w-6" /><Skeleton className="size-8 rounded-full" /><Skeleton className="h-4 flex-1" /><Skeleton className="h-4 w-20" /><Skeleton className="h-4 w-10" /><Skeleton className="h-4 w-16" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

// ---------------------------------------------------------------------------
// Component — 5 placeholder rows
// ---------------------------------------------------------------------------

export function MarketBackersSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PanelHeader><Skeleton className="h-5 w-40" /></PanelHeader>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Panel data-testid="market-backers-skeleton">{t0}<PanelContent className="flex flex-col"><RowSkeleton /><RowSkeleton /><RowSkeleton /><RowSkeleton /><RowSkeleton /></PanelContent></Panel>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}